<p-dialog
  header="Nuevo País"
  [(visible)]="visible"
  [modal]="true"
  (onHide)="closeDialog()"
  [closable]="true"
  [style]="{ width: '25%', height: '55vh' }"
>
  <div class="flex flex-column gap-3 mb-3">
    <div class="field">
      <label for="country" class="font-semibold">País</label>
      <input
        pInputText
        id="country"
        type="text"
        [(ngModel)]="country"
        (ngModelChange)="onChangeInput($event, 'country')"
        [placeholder]="'Ingresa nombre del país'"
      />
      <div
        *ngIf="!country && hasInteracted['country']"
        style="color: red; font-size: 0.875rem; margin-top: 5px"
      >
        Este campo es obligatorio.
      </div>
    </div>

    <br />
    <div class="field">
      <label for="codeCountry" class="font-semibold"
        >Código del nombre del País</label
      >
      <input
        pInputText
        id="codeCountry"
        type="text"
        [(ngModel)]="codeCountry"
        (ngModelChange)="onChangeInput($event, 'codeCountry')"
        [placeholder]="'Ingresa código'"
      />
      <div
        *ngIf="!codeCountry && hasInteracted['codeCountry']"
        style="color: red; font-size: 0.875rem; margin-top: 5px"
      >
        Este campo es obligatorio.
      </div>
    </div>

    <br />
    <div class="field">
      <label for="phoneCode" class="font-semibold">Código de Celular</label>
      <p-inputNumber
        id="phoneCode"
        type="text"
        [(ngModel)]="phoneCode"
        [maxFractionDigits]="0"
        [min]="0"
        (ngModelChange)="onChangeInput($event, 'phoneCode')"
        [placeholder]="'Ingresa código'"
      />
      <div
        *ngIf="!phoneCode && hasInteracted['phoneCode']"
        style="color: red; font-size: 0.875rem; margin-top: 5px"
      >
        Este campo es obligatorio.
      </div>
    </div>
  </div>

  <div
    style="display: flex; justify-content: center; gap: 10px; margin-top: 10px"
  >
    <!-- Botón Aceptar -->
    <button
      type="button"
      pButton
      label="Registrar"
      [disabled]="isDisabled"
      (click)="onRegister()"
      class="btn"
    ></button>
  </div>
</p-dialog>
